<template>
  <d2-container>
    <el-card>
      <div class="center">墓位信息</div>
      <div class="font qu">
        <div>客户姓名：{{ name }}</div>
      </div>
      <div class="font qu">
        <div>墓穴名称：{{ thombtypename }} {{ tombname }}{{ rowno }}排{{ columno }}号</div>

      </div>
      <div class="font qu">
        <div>全款时间：{{ time }}</div>

      </div>
       <div class="font qu">
        <div>底价：{{ basePrice }}</div>

      </div>
      <div class="font qu">
        <div>成交金额：{{ money }}</div>
      </div>
      <div class="font qu">
        <div>提成金额： {{ accAdd(accAdd(accAdd(receptionMoney, bazaarMoney), accAdd(marketMoney,
            geomancerMoney)), blocsMoney) || '--'
        }}</div>
      </div>
      <div class="font qu">
        <div>申请人：{{ createdby }}</div>
      </div>
      <div class="fle">


      </div>
    </el-card>
    <div style="text-align: center; font-size: 17px">
      <el-table :data="tableData" :show-header="false" border style="width: 100%; margin-top: 20px">
        <el-table-column prop="key"> </el-table-column>
        <el-table-column prop="value"> </el-table-column>
      </el-table>
    </div>
    <!-- height="500" -->


    <div style="text-align: center; margin-top: 15px">
      <el-button type="danger" @click="Audit" v-if="this.auditState == 0">审核驳回</el-button>
      <el-button style="margin-left: 20px" type="primary" @click="onSubmit" v-if="this.auditState == 0">审核通过</el-button>
      <el-table :data="tableData" :show-header="false" border style="width: 100%; margin-top: 20px">
      </el-table>
    </div>

    <div v-if="this.auditState == 2">
      <div class="overrule">驳回原因：</div>
      <div class="layout" style="margin-top: 10px">

        <el-input type="textarea" :rows="5" v-model="auditMsg" readonly></el-input>

      </div>
    </div>
    <el-dialog v-if="dialogFormVisible" title="驳回原因" :visible.sync="dialogFormVisible" width="90%"
      :close-on-click-modal="false">
      <el-input type="textarea" :rows="5" v-model="auditmsg" maxlength="50" show-word-limit></el-input>

      <div style="text-align: center; margin-top: 10px">
        <el-button type="primary" @click="bao">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="dialogVisible" width="90%" :before-close="handleClose">
      <span v-html="this.prompt"></span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </d2-container>
</template>

<script>
import { mapActions } from "vuex";
import mathUtil from "../../utils/mathUtil";
export default {
  name: "index",
  data() {
    return {
      name: "",
      tombname: "",
      columno: "",
      rowno: "",
      thombtypename: "",
      createdby: "",
      time: "",
      money: "",
      labelPosition: "right",
      dialogFormVisible: false,
      dialogVisible: false,
      // groupId: "",
      auditmsg: "",
      auditMsg: "",
      auditState: "",
      id: 0,
      // result: 0,
      status: "",
      // update: "",
      prompt: "",
      tableData: [],
      rules: {},
      receptionMoney: 0,
      bazaarMoney: 0,
      marketMoney: 0,
      geomancerMoney: 0,
      blocsMoney: 0,
      basePrice:0
    };
  },
  created() {
    this.feachdata();
  },
  methods: {
    ...mapActions("d2admin/Commission", [
      "apioperateFullCommissionApproval",
      "apicommissionApplyById",
    ]),

    feachdata() {
      this.loading = this.$loading({
        fullscreen: true,
        text: "处理中",
        background: "rgba(0, 0, 0, 0.6)",
      });
      console.log("aa");
      const param = {
        applyId: this.$route.query.applyId,
      };
      console.log(param);
      // debugger;
      this.apicommissionApplyById(param).then((res) => {
        console.log(res.data)
        this.name = res.data.tomb.cust.custName
        this.tombname = res.data.tomb.area.areaName
        this.columno = res.data.tomb.columNo
        this.createdby = res.data.createdBy
        this.rowno = res.data.tomb.rowNo
        this.thombtypename = res.data.tomb.tombType.thombTypeName
        this.money = res.data.clinchMoney
        this.basePrice = res.data.tomb.basePrice
        this.time = this.formatDate(res.data.fullTime * 1000)
        if (res.data.receptionName) {
          this.tableData.push({
            key: "接待部主卖姓名",
            value: res.data.receptionName,
          });
        }
        if (res.data.receptionPointType) {
          this.tableData.push({
            key: "接待部提点类型",
            value: res.data.receptionPointType,
          });
        }
        if (res.data.receptionMoney) {
          this.tableData.push({
            key: "接待部主卖提成金额",
            value: res.data.receptionMoney,
          });
        }
        if (res.data.otherReceptionName) {
          this.tableData.push({
            key: "其他接待人员",
            value: res.data.otherReceptionName,
          });
        }
        
        if (res.data.otherReceptionMoney) {
          this.tableData.push({
            key: "接待部其他提成金额",
            value: res.data.otherReceptionMoney,
          });
        }

        // if (res.data.receptionMoney == 0) {
        //   console.log('ss')
        //   this.tableData.push({
        //     key: "接待部提成金额",
        //     value: "0",
        //   });
        // } else {
        //   this.tableData.push({
        //     key: "接待部提成金额",
        //     value: res.data.receptionMoney,
        //   });
        // }
        if (res.data.bazaarName) {
          this.tableData.push({
            key: "市场部人员姓名",
            value: res.data.bazaarName,
          });
        }
        if (res.data.bazaarPointType) {
          this.tableData.push({
            key: "市场部提点类型",
            value: res.data.bazaarPointType,
          });
        }
        if (res.data.bazaarMoney) {
          this.tableData.push({
            key: "市场部提成金额",
            value: res.data.bazaarMoney,
          });
        }
        if (res.data.marketName) {
          this.tableData.push({
            key: "营销部人员姓名",
            value: res.data.marketName,
          });
        }
        if (res.data.marketPointType) {
          this.tableData.push({
            key: "营销部提点类型",
            value: res.data.marketPointType,
          });
        }
        if (res.data.marketMoney) {
          this.tableData.push({
            key: "营销部提成金额",
            value: res.data.marketMoney
            ,
          });
        }

        if (res.data.geomancerName) {
          this.tableData.push({
            key: "风水先生姓名",
            value: res.data.geomancerName,
          });
        }
        if (res.data.geomancerType) {
          this.tableData.push({
            key: "风水先生提点类型",
            value: res.data.geomancerType,
          });
        }
        if (res.data.geomancerMoney) {
          this.tableData.push({
            key: "风水先生提成金额",
            value: res.data.geomancerMoney
            ,
          });
        }
        if (res.data.blocsName) {
          this.tableData.push({
            key: "集团员工姓名",
            value: res.data.blocsName,
          });
        }
        if (res.data.blocsType) {
          this.tableData.push({
            key: "集团员工提点类型",
            value: res.data.blocsType,
          });
        }
        if (res.data.blocsMoney) {
          this.tableData.push({
            key: "集团员工提成金额",
            value: res.data.blocsMoney
            ,
          });
        }

        if (res.data.auditState == 0) {
          this.status = "未审核";
        } else if (res.data.auditState == 1) {
          this.status = "已审核";
        } else if (res.data.auditState == 2) {
          this.status = "驳回";
        }
        this.tableData.push({
          key: "审核人",
          value: res.data.auditPerson
          ,
        });
        console.log(res.data.auditState)
        this.auditState = res.data.auditState
        this.auditMsg = res.data.auditMsg
        this.receptionMoney = res.data.receptionMoney
        this.bazaarMoney = res.data.bazaarMoney
        this.marketMoney = res.data.marketMoney
        this.geomancerMoney = res.data.geomancerMoney
        this.blocsMoney = res.data.blocsMoney
        this.tableData.push({ key: "状态", value: this.status });
        this.id = res.data.id;


        this.loading.close()
      }).catch(() => {
        this.loading.close()
      })
    },
    onSubmit() {
      this.loading = this.$loading({
        fullscreen: true,
        text: "处理中",
        background: "rgba(0, 0, 0, 0.6)",
      });
      const param = {
        applyId: this.id,
        openId: this.$route.query.openid,
        operate: "AGREE",
        auditMsg: this.auditmsg,
      };
      console.log(param);
      this.apioperateFullCommissionApproval(param)
        .then((res) => {
          this.prompt = res.data.msg;
          console.log(res);
          this.loading.close();
          this.dialogVisible = true;
          this.status = "已审核";
          this.tableData = [];
          this.feachdata();
        })
        .catch((err) => { });
    },
    Audit() {
      this.dialogFormVisible = true;
    },
    bao() {
      const param = {
        applyId: this.id,
        openId: this.$route.query.openid,
        operate: "REFUSE",
        auditMsg: this.auditmsg,
      };
      console.log(param);
      this.apioperateFullCommissionApproval(param).then((res) => {
        this.dialogFormVisible = false;
        this.prompt = res.data.msg;
        this.dialogVisible = true;
        // this.$alert(res.data.msg, "操作提示", {
        //       confirmButtonText: "确定",
        // });
        this.status = "驳回";
        this.tableData = [];
        this.feachdata();
      });
    },
    handleClose(done) {
      done();
    },
    formatDate(value) {
      if (value) {
        var dateVal = new Date(value)
        var year = dateVal.getFullYear()
        var month = dateVal.getMonth() + 1
        month = month < 10 ? "0" + month : month
        var day = dateVal.getDate() < 10 ? "0" + dateVal.getDate() : dateVal.getDate()

        return year + "-" + month + "-" + day
      } else {
        return ""
      }
    },
    accAdd(number1, number2) {
      number1 = Number(number1)
      number2 = Number(number2)
      return mathUtil.accAdd(number1, number2)
    },
  },
};
</script>
<style  scoped>
.layout {
  width: 95%;
  margin: 10px;
  /* text-align: center; */
}

::v-deep .el-textarea__inner:focus {
  border-color: #DCDFE6 !important;
}

.overrule {
  margin-left: 10px;
}

.fle {
  display: flex;
  justify-content: space-around;
}

.center {
  text-align: center;
  font-size: 20px;
  margin-top: 5px;
  margin-bottom: 10px;
}

.font {
  font-size: 16px;
  color: #7d7d7d;
}

.qu {
  margin-bottom: 5px;
}
</style>
